import React from 'react';
import Icon from '../../Icon/components/Icon';

const ParagraphIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M13 4v16"/>
      <path d="M17 4v16"/>
      <path d="M19 4H9.5a4.5 4.5 0 0 0 0 9H13"/>
    </Icon>
  );
};

export default ParagraphIcon;
